import createIcon from '../../createIcon';

/**
 * @component @name Stadium
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyA1LjA2MDU1TDMgNy4wNjA1NVYzLjA2MDU1TDcgNS4wNjA1NVpNMTggMy4wNjA1NVY3LjA2MDU1TDIyIDUuMDYwNTVMMTggMy4wNjA1NVpNMTEgMi4wNjA1NVY2LjA2MDU1TDE1IDQuMDYwNTVMMTEgMi4wNjA1NVpNNSAxMC4xMDA1QzYuMzggMTAuNTkwNSA4Ljc3IDExLjA2MDUgMTIgMTEuMDYwNUMxNS4yMyAxMS4wNjA1IDE3LjYyIDEwLjU5MDUgMTkgMTAuMTAwNUMxOSA5LjkyMDU1IDE2LjIyIDkuMDYwNTUgMTIgOS4wNjA1NUM3Ljc4IDkuMDYwNTUgNSA5LjkyMDU1IDUgMTAuMTAwNVpNMTUgMTcuMDYwNUg5VjIxLjk0MDVDNC45NCAyMS41NTA1IDIgMjAuNDAwNSAyIDE5LjA2MDVWMTAuMDYwNUMyIDguNDAwNTUgNi40OCA3LjA2MDU1IDEyIDcuMDYwNTVDMTcuNTIgNy4wNjA1NSAyMiA4LjQwMDU1IDIyIDEwLjA2MDVWMTkuMDYwNUMyMiAyMC40MDA1IDE5LjA2IDIxLjU0MDUgMTUgMjEuOTMwNVYxNy4wNjA1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Stadium = createIcon('Stadium', [
  [
    'path',
    {
      d: 'M7 5.06055L3 7.06055V3.06055L7 5.06055ZM18 3.06055V7.06055L22 5.06055L18 3.06055ZM11 2.06055V6.06055L15 4.06055L11 2.06055ZM5 10.1005C6.38 10.5905 8.77 11.0605 12 11.0605C15.23 11.0605 17.62 10.5905 19 10.1005C19 9.92055 16.22 9.06055 12 9.06055C7.78 9.06055 5 9.92055 5 10.1005ZM15 17.0605H9V21.9405C4.94 21.5505 2 20.4005 2 19.0605V10.0605C2 8.40055 6.48 7.06055 12 7.06055C17.52 7.06055 22 8.40055 22 10.0605V19.0605C22 20.4005 19.06 21.5405 15 21.9305V17.0605Z',
      key: '1krznd',
    },
  ],
]);

export default Stadium;
